import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { OrganisationProductsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createOrganisationProduct = (data): any => action(types.CREATE_ORGANISATION_PRODUCT_REQUESTED, data);

export const updateOrganisationProduct = (data): any => action(types.UPDATE_ORGANISATION_PRODUCT_REQUESTED, data);

export const deleteOrganisationProduct = (organisationProductId): any => action(types.UPDATE_ORGANISATION_PRODUCT_REQUESTED, organisationProductId);

export const getOrganisationProduct = (organisationProductId): any => action(types.GET_ORGANISATION_PRODUCT_REQUESTED, organisationProductId);

export const getAllOrganisationProducts = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ORGANISATION_PRODUCTS_REQUESTED, {
  pagination,
  compile,
});

export const selectOrganisationProduct = (organisationProductId): any => action(types.SELECT_ORGANISATION_PRODUCT_REQUESTED, {
  currentOrganisationProductId: organisationProductId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createOrganisationProductPending: (payload): any => action(types.CREATE_ORGANISATION_PRODUCT_PENDING, payload),
  createOrganisationProductSuccess: (response): any => {
    const currentOrganisationProduct = response.entities.organisationProducts[response.result];
    // history.push(`/payment/${currentOrganisationProduct.paymentCollection.id}/review`);
    return action(types.CREATE_ORGANISATION_PRODUCT_SUCCESS, {
      organisationProductsById: response.entities.organisationProducts,
      currentOrganisationProductId: response.result,
    });
  },
  updateOrganisationProductPending: (payload): any => action(types.UPDATE_ORGANISATION_PRODUCT_PENDING, payload),
  updateOrganisationProductSuccess: (response): any => action(types.UPDATE_ORGANISATION_PRODUCT_SUCCESS, {
    organisationProductsById: response.entities.organisationProducts,
    currentOrganisationProductId: response.result,
  }),
  updateOrganisationProductFailed: (error): any => action(types.UPDATE_ORGANISATION_PRODUCT_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationProductPending: (): any => action(types.UPDATE_ORGANISATION_PRODUCT_PENDING, {}),
  deleteOrganisationProductSuccess: (response, userId): any => {
    localStorage.set(userId, { currentOrganisationProductId: null });
    history.push('/organisationProducts');

    return action(types.DELETE_ORGANISATION_PRODUCT_SUCCESS, {
      currentOrganisationProductId: response,
    });
  },
  getOrganisationProductPending: (): any => action(types.GET_ORGANISATION_PRODUCT_PENDING, {}),
  getOrganisationProductSuccess: (response): any => action(types.GET_ORGANISATION_PRODUCT_SUCCESS, {
    organisationProductsById: response.entities.organisationProducts,
    currentOrganisationProductId: response.result,
  }),
  getOrganisationProductFailed: (error): any => action(types.GET_ORGANISATION_PRODUCT_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationProductFailed: (error): any => action(types.UPDATE_ORGANISATION_PRODUCT_FAIL, {
    backendErrors: error,
  }),
  getAllOrganisationProductsPending: (pagination): any => action(types.GET_ALL_ORGANISATION_PRODUCTS_PENDING, { pagination }),
  getAllOrganisationProductsSuccess: (response, meta): any => action(types.GET_ALL_ORGANISATION_PRODUCTS_SUCCESS, {
    organisationProductsById: response.entities.organisationProducts,
    organisationProductIds: response.result,
    meta,
  }),
  getAllOrganisationProductsFailed: (error): any => action(types.GET_ALL_ORGANISATION_PRODUCTS_FAIL, {
    backendErrors: error,
  }),
  createOrganisationProductFailed: (error): any => action(types.CREATE_ORGANISATION_PRODUCT_FAIL, {
    backendErrors: error,
  }),
};

export default null;
